<template>
    <div v-if="verifyEmailLink" class="banner">
        <div class="container">
            <p class="mb-0">
                <span v-text="$t('global.verify-email.banner.text', { email })" />
                <a class="pointer"
                   tabindex="0"
                   @click="resendEmail"
                   v-text="$t('global.verify-email.banner.btn-text')"
                />
                <span v-if="resendEmailLoading" class="spinner-border spinner-border-sm text-muted" role="status">
                    <span class="sr-only">Loading...</span>
                </span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            verifyEmailLink: null,
            resendEmailLoading: false,
            email: null,
        };
    },
    async mounted() {
        if (!this.$store.user) {
            return;
        }
        let user = await this.$store.$userRepository.get();
        this.email = user.email;
        if (!user.verifiedEmail) {
            this.verifyEmailLink = user.links.verifyEmail;
        }
    },
    methods: {
        async resendEmail() {
            this.resendEmailLoading = true;
            await this.$store.$axios.get(this.verifyEmailLink);
            this.resendEmailLoading = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/css/_base';
.banner {
  background: $light-blue;
  padding-top: .5rem;
  padding-bottom: .5rem;
}
.pointer {
    cursor: pointer;
}
</style>
